<template>
  <div class="btn-pet" :class="{ 'btn-pet-active': active }" @click="selectPet">
    <div class="btn-pet-name">{{pet.name}}</div>
    <div class="btn-pet-breed">{{breedName}}</div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { BreedCacheMixin } from '@/mixins/Booking/BreedCacheMixin'

export default {
  name: 'PetSelectItem',
  mixins: [BreedCacheMixin],
  props: {
    pet: Object
  },
  computed: {
    ...mapState('BookingUpload', [
      'selectedPets'
    ]),
    petWithPetId () {
      return Object.assign({}, this.pet, { petId: this.pet.id, serviceItems: [], appointmentDuration: 0 })
    },
    breedId () {
      return this.pet ? this.pet.breedId : ''
    },
    selectedPetIds () {
      return this.selectedPets.length > 0 ? this.selectedPets.map(p => p.id) : []
    },
    active () {
      return this.selectedPetIds.includes(this.pet.id)
    }
  },
  methods: {
    selectPet () {
      this.$emit('petSelected', this.petWithPetId)
    }
  }
}
</script>
